import React, { useEffect, useState } from 'react'
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import { getThumbnailUrlFromEmbedLink } from '../../../helper/getThumbnailUrlFromEmbedLink';
import { aedLogoStyle, getDirhamImage, iconContainer, pageTitle, showIconsContainer, termsTitle, whiteCard } from '../../../common/cssclasses';
import { useTranslate } from '../../../components/TranslationText';
import NewActionButton from '../../../components/ActionButtons/NewActionButton';
import { formatDate } from '../../../helper/formatDate';
import { useLocation, useNavigate } from 'react-router';
import { getSemenById } from '../Api/semenMarketApi';
import ImagesSlider from "../../../components/ImagesSlider";

export default function SemenDetailsPage() {
    const { translate } = useTranslate();
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const id = searchParams.has("semenId") ? searchParams.get("semenId") : null;
    const currentlang = localStorage.getItem('eahsLang') ?? 'en';
    const renderVideo = (item) => {
        return (
            <div className="">
                {item.video === true ? (
                    <iframe
                        width="100%"
                        src={item.embedUrl}
                        frameBorder="0"
                        allowFullScreen={false}
                        style={{ aspectRatio: '16/9' }}
                        title="ex"
                    />
                ) : (
                    <React.Fragment></React.Fragment>
                )}
            </div>
        );
    };


    const [semen, setSemen] = useState({});

    function fetchSemen() {
        getSemenById(id).then(res => setSemen(res));
    }
    console.log('gallery stallionImage: ', semen?.stallionImage);
    const gallery = semen?.stallionImage?.map((item) => (item.fileType === 'Image' ? { original: item.fileUrl, thumbnail: item.fileUrl } : { embedUrl: item.fileUrl, thumbnail: getThumbnailUrlFromEmbedLink(item.fileUrl), video: true, renderItem: renderVideo })) || [];
    console.log('gallery: ', gallery);

    useEffect(() => {
        fetchSemen()
    }, [])


    return (
        <div className='row'>
            <h2 className={termsTitle + " d-flex align-items-center flex-wrap mb-main"}>
                {!!semen?.regNr && semen.regNr + " - "} {semen?.horseName}
                <div className='ms-auto d-flex flex-column align-items-center'>
                    <NewActionButton
                        classNames='btn-danger w-unset'
                        text={translate('web.buyNow', 'Buy Now')}
                        key={'buyNow'}
                        disabled={semen?.isOutOfStock}
                        onClick={(e) => { navigate(`/semenCheckout?semenMarketId=${id}`) }}
                    />
                    {semen?.isOutOfStock && (
                        <span className='text-danger text-center w-100' style={{ fontSize: '12px', fontWeight: 'bold', marginTop: '4px' }}>
                            {translate('web.semenMarketNotAvailableNow', 'Semen Market Not Available Now')}
                        </span>
                    )}
                </div>
            </h2>
            <div className={showIconsContainer}>
                {detailsRow('fa fa-user', 'web.owner', semen?.owner, 'w-unset')}

                <div className={iconContainer}>
                    <img src={getDirhamImage(currentlang)} alt='AED' style={aedLogoStyle} />
                    <span className='fw-bold'>{`${translate("web.price", "Price") + ": "}`} {semen?.price?.toLocaleString("en-US")} {translate('web.aed', 'AED')}</span>
                </div>



            </div>
            <div className='col-md-8 col-12'>
                <style>
                    {`
                    .image-gallery { border-radius:15px; overflow:hidden; }
                    .image-gallery-slide img {
                        height: 450px;
                        object-fit: contain;
                        background-color: #f8f9fa;
                    }
                    .image-gallery-thumbnail-inner img {
                        height: 80px;
                        object-fit: cover;
                    }
                    `}
                </style>
                <div className={whiteCard}>
                    {gallery.length > 0 && (
                        <ImageGallery
                            items={gallery}
                            showPlayButton={false}
                            showIndex={true}
                            showFullscreenButton={true}
                        />
                    )}
                </div>
            </div>
            <div className='col-md-4 col-12'>
                <div className={whiteCard}>
                    {semen?.description && (
                        <div className="mb-4">
                            <h5 className="fw-bold C89C66 mb-2">{translate('web.horseDescription', 'Description')}</h5>
                            <p className="mb-0" style={{ whiteSpace: 'pre-line', lineHeight: '1.6' }}>{semen.description}</p>
                        </div>
                    )}
                    {rightDetails('fa fa-calendar', 'web.birthDate', semen?.birthDate)}
                    {rightDetails('fa fa-palette', 'web.color', semen?.color)}
                    {rightDetails('fa fa-earth-americas', 'web.origin', semen?.origin)}
                    {rightDetails('fa fa-tags', 'web.sire', semen?.sireName)}
                    {rightDetails('fa fa-tags', 'web.dam', semen?.damName)}
                    {rightDetails('fa fa-envelope', 'web.email', semen?.ownerMail)}
                    {rightDetails('fa fa-phone', 'web.phone', semen?.ownerPhone)}
                    {rightDetails('fa fa-location-dot', 'web.address', semen?.address)}
                    <div className='row'>
                        <div className='ms-auto w-unset d-flex align-items-center flex-wrap'>
                            <NewActionButton
                                classNames='btn-outline-danger w-unset'
                                text={translate('web.StudBookDetails', 'StudBook Details')}
                                onClick={(e) => { navigate(`/horsedetails?horseId=${semen?.stallionId}`) }}
                            />
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
    function detailsRow(icon = '', key = "", value = "", classNames = "") {
        return <div className={iconContainer + ' ' + classNames}>
            <i className={`${icon} C89C66`} />
            <span className='fw-bold' >{translate(key, key) + ": "} {!!value
                ? value
                : translate("web.unknown", "unknown")} </span>
        </div>;
    }
    function rightDetails(icon = '', key = "", value = "") {
        if (!value) return <></>
        return <div className='col-sm-12 col-12 mb-2'>
            <span className="fw-bold">
                <i className={`${icon} C89C66 me-2`} />
                {translate(key, key) + ":"}
            </span>
            <span className="fw-bold ms-2">
                {!!value
                    ? value : '-'}
                {/* // : translate("web.unknown", "unknown")} */}
            </span>
        </div>;
    }
}
